// extracted by mini-css-extract-plugin
export default {"IconWrapper":"FavouriteBadge_IconWrapper__1AcZ6","IconWrapper__Icon":"FavouriteBadge_IconWrapper__Icon__I+03X"};